import { Box } from '@mui/material'
import PropTypes from 'prop-types'

/**
 * Renders an image as a solid-fill mask, tinted with the theme's
 * `primary.main`, instead of an `<img>` — see org-sidebar-logo design D1.
 *
 * The mask uses the source image's alpha channel, so transparent PNGs and
 * translucent SVG layers survive as tints of the accent colour, and the
 * colour follows the viewing user's colour preset, any partner colour
 * override, and dark mode with no refetch. No SVG markup is ever fetched or
 * inlined by this component — the mask references the URL directly, exactly
 * like a CSS `background-image`, so there is nothing here to sanitise or
 * parse and no XSS surface in the app.
 *
 * The mask properties are plain CSS with no theme-token lookup, so they're
 * set via the native `style` prop rather than `sx` — only the accent fill
 * (`bgcolor: 'primary.main'`) needs `sx`'s theme resolution.
 */
const MaskedLogo = ({ src, label, width, height, sx }) => {
    const maskImage = `url("${src}")`

    return (
        <Box
            role="img"
            aria-label={label}
            sx={{ bgcolor: 'primary.main', width, height, ...sx }}
            style={{
                maskImage,
                WebkitMaskImage: maskImage,
                maskSize: 'contain',
                WebkitMaskSize: 'contain',
                maskRepeat: 'no-repeat',
                WebkitMaskRepeat: 'no-repeat',
                maskPosition: 'center',
                WebkitMaskPosition: 'center'
            }}
        />
    )
}

MaskedLogo.propTypes = {
    src: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
}

export default MaskedLogo
